import { createSelector } from '@reduxjs/toolkit';

import { selectors as parentSelectors } from '../selectors';
import { createPaginationSelectors } from '../../../_pagination';

const selectStore = createSelector(
  [parentSelectors.selectStore],
  (parent) => parent.completedLessons
);

const selectors = createPaginationSelectors({ selectStore });

export { selectors };
